/**
 * Page builder for the OPSI custom post type only.
 * Each ACF row renders only the fields defined for its choose_a_section layout.
 */

import { OpsiSection } from "./OpsiSection";

const getOpsiSections = (post) => {
  try {
    return post?.acf?.sections ?? post?.sections ?? [];
  } catch {
    return [];
  }
};

export const OpsiPageBuilder = ({ post }) => {
  const sections = getOpsiSections(post);

  if (!Array.isArray(sections) || !sections.length) {
    return (
      <div className="opsi-page-builder opsi-page-builder--empty">
        <p>No OPSI sections configured for this page.</p>
      </div>
    );
  }

  let count = 0;

  return (
    <div className="opsi-page-builder flex w-full flex-col gap-[37px] px-0">
      {sections.map((section) => {
        count += 1;
        const sectionType = section?.choose_a_section;

        return (
          <OpsiSection
            key={`${sectionType || "section"}-${count}`}
            id={`opsi-section-${count}`}
            section={section}
          />
        );
      })}
    </div>
  );
};
